function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import get from 'lodash.get';
import React, { useState, useCallback, useMemo } from 'react';
import { RangeControlType } from '../../range/Range';
import { useFormContext } from '../FormContext';
import { getError } from '../utils';
function RangeAdapter(RangeType) {
  const FormRangeField = _ref => {
    let {
      name,
      dataRef,
      value,
      disabled: externalDisabled,
      onChange,
      onBlur,
      printValue,
      onSuggestionSelected,
      ...rest
    } = _ref;
    const {
      loading,
      disabled,
      errors,
      touched,
      submitCount,
      handleBlur,
      handleChange,
      setFieldValue
    } = useFormContext();
    const [isEditing, setIsEditing] = useState(false);
    const internalHandleChange = useCallback(e => {
      handleChange(e);
      setIsEditing(true);
      if (onChange) {
        onChange(e);
      }
    }, [handleChange, onChange]);
    const error = useCallback(type => getError(submitCount > 0, `${name}.${type}`, touched, errors), [errors, name, submitCount, touched]);
    const minError = useMemo(() => error(RangeControlType.MIN), [error]);
    const maxError = useMemo(() => error(RangeControlType.MAX), [error]);
    const internalHandleBlur = useCallback(e => {
      handleBlur(e);
      setIsEditing(false);
      if (onBlur) {
        onBlur(e);
      }
    }, [handleBlur, onBlur]);
    const getValue = useCallback(type => get(value, type, undefined), [value]);
    const refName = useMemo(() => dataRef || name, [dataRef, name]);
    const onInternalSuggestionSelected = useCallback((suggestion, controlType) => {
      setFieldValue(`${name}.${controlType}`, suggestion.value);
      setIsEditing(false);
      if (onSuggestionSelected) {
        onSuggestionSelected(suggestion, controlType);
      }
    }, [name, onSuggestionSelected, setFieldValue]);
    const onMinGreaterThanMax = useCallback((minValue, maxValue) => {
      if (!isEditing) {
        setFieldValue(`${name}.${RangeControlType.MIN}`, maxValue);
        setFieldValue(`${name}.${RangeControlType.MAX}`, minValue);
      }
    }, [isEditing, name, setFieldValue]);
    return /*#__PURE__*/React.createElement(RangeType, _extends({
      minValue: getValue(RangeControlType.MIN),
      maxValue: getValue(RangeControlType.MAX),
      minError: !!minError,
      maxError: !!maxError
    }, rest, {
      printValue: printValue,
      minName: `${name}.${RangeControlType.MIN}`,
      maxName: `${name}.${RangeControlType.MAX}`,
      onChange: internalHandleChange,
      onBlur: internalHandleBlur,
      disabled: loading || disabled || externalDisabled,
      loading: loading,
      dataRef: refName,
      onSuggestionSelected: onInternalSuggestionSelected,
      onMinGreaterThanMax: onMinGreaterThanMax
    }));
  };
  return FormRangeField;
}
export default RangeAdapter;
//# sourceMappingURL=RangeAdapter.js.map